<template>
  <select class="k-select-container" name="selector-of-filter-custom" @change="onChange($event)">
    <option v-for="(item, index) of data" :key="index" class="select-item" :value="item.value">
      <span>{{ item.name }} </span>
    </option>
  </select>
</template>

<script>
export default {
	name: 'KSelect',
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		onChange(event) {
			this.$emit('on-change', event.target.value);
		},
	},
};
</script>

<style lang="scss" scoped>
.k-select-container {
	border: unset;
}
.select-item {
	padding: 5px;
}
.select-item * {
	font-weight: bold !important;
}
</style>
